import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router";

export default function SuccessFulSubmission() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: "#f0fbf7",
        gap: 1,
        // backgroundColor: "#f0f8ff",
        textAlign: "center",
        // padding: "2rem",
      }}
    >
      <Typography sx={{ color: "primary.main" }} variant="h3">
        🎉 Submission Successful!
      </Typography>
      <Typography sx={{ fontSize: 18 }}>
        Thank you! Your form has been submitted successfully.
      </Typography>
      <Button
        variant="contained"
        onClick={handleBack}
        sx={{
          mt: 2,
          backgroundColor: "#1B8B7F",
          "&:hover": { backgroundColor: "#16796F" },
        }}
      >
        Back to Registration Page
      </Button>
    </Box>
  );
}
